import React, {
  memo, useCallback, useEffect, useMemo,
} from 'react'
import { useInfiniteQuery } from 'react-query'
import { useRouter } from 'next/router'
import Grid from '@mui/material/Grid2'
import LinearProgress from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'
import Quoter from 'components/shared/Quoter'
import useUtms from 'hooks/useUtms'
import Contact from 'components/shared/Contact'
import { getFilterObject } from 'filters'
import { getAuctionVehicles } from 'utils/universal/getAuctionVehicles'
import { getVehicleAuctionLink } from 'utils/vehicles'
import useIntersectionObserver from 'hooks/useIntersectionObserver'
import { useMediaQuery } from '@mui/material'
import VehicleAuctionCard from 'components/Auction/VehicleAuctionCard/VehicleAuctionCard'
import envs from 'envs'
import { useSession } from 'next-auth/react'
import { useDispatch } from 'react-redux'
import { setValue } from 'redux/modules/auction'
import sx from './styles'

const VehicleList = (props) => {
  const {
    sx: sxProp,
    // setAutosCount,
    section = 'SRP',
  } = props
  const router = useRouter()
  const dispatch = useDispatch()
  const filters = useMemo(() => getFilterObject(router.query?.params), [router.query?.params])
  const query = useUtms()
  const vehiclesPerPage = envs?.vehiclesAuctionsPerPage
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))
  const showMobileCardVariant = useMemo(() => isMobile, [isMobile])
  const formattedFilters = { ...filters }
  const { data: session } = useSession()
  const token = session?.user?.accessToken

  const {
    status,
    data,
    error,
    isFetching,
    // isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    // isFetchingPreviousPage,
    // fetchPreviousPage,
    // hasPreviousPage,
    // refetch,
  } = useInfiniteQuery(
    ['vehiclesAuctions', section, router.query?.params],
    ({ pageParam = 0 }) => getAuctionVehicles(
      {
        ...formattedFilters,
        page: pageParam,
      },
      vehiclesPerPage,
      section,
      token,
    ),
    {
      enabled: Boolean(token),
      staleTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      keepPreviousData: true,
      getPreviousPageParam: (firstPage) => firstPage?.pagination?.previousPage ?? false,
      getNextPageParam: (lastPage) => lastPage?.pagination?.nextPage ?? false,
    },
  )
  // const dataAutosCount = data?.pages[0]?.inventory?.length > 0
  // useEffect(() => {
  //   setAutosCount(data?.pages[0]?.inventory?.length)
  // }, [data?.pages[0]])

  // useEffect(() => {
  //   if (status === 'success') {
  //     if (data?.pages[0]?.inventory?.length > 0) {
  //       setAuctionId(data?.pages[0]?.inventory[0]?.auction?.auctionEvent?.id)
  //     } else {
  //       setAuctionId(null)
  //     }
  //   }
  // }, [status])

  const loadMoreButtonRef = React.useRef()

  useIntersectionObserver({
    target: loadMoreButtonRef,
    onIntersect: fetchNextPage,
    enabled: hasNextPage,
  })

  // const loadMoreButtonText = isFetchingNextPage
  //   ? 'LOADING_MORE' : hasNextPage
  //     ? 'LOAD_MORE'
  //     : 'END_OF_RESULTS'

  const mergeVehiclesWithBanners = useCallback((vehicles) => {
    if (!vehicles) return []
    return vehicles
  }, [data])

  const renderQuoter = (banner, index) => (
    <Grid
      key={`banner-${index}`}
      size={{
        xs: 12,
        sm: 12,
        md: 6,
        lg: 3,
      }}
      sx={{ paddingTop: '0px!important' }}
    >
      <Quoter
        title="SEARCH_LIST_BANER_FORM_QUOTER"
        buttonId="srp_componente_cotizador"
        variant="column"
        isCard
        sx={sx.quoter}
      />
    </Grid>
  )

  const renderItem = useCallback((item, index) => {
    if (item?.type === 'card') {
      return renderQuoter(item, index)
    }

    return (
      <Grid
        key={`vehicle-${item.id}`}
        size={{
          xs: 12,
          sm: 12,
          md: 6,
          lg: 3,
        }}
      >
        <VehicleAuctionCard
          swiper
          direction="column"
          vehicle={item}
          showPayments
          href={`${getVehicleAuctionLink(item)}${query}`}
          priority={index < 2}
          index={index + 1}
        />
      </Grid>
    )
  }, [query, isMobile, showMobileCardVariant])

  const auctionEvent = data?.pages?.length > 0
    ? data?.pages[0]?.inventory?.length > 0
      ? data?.pages[0]?.inventory[0]?.auction?.auctionEvent
      : null
    : null

  useEffect(() => {
    if (auctionEvent) {
      dispatch(setValue({
        key: 'auctionSelected',
        value: auctionEvent,
      }))
    }
  }, [auctionEvent])

  if (status === 'success') {
    return (
      <>
        <Box sx={{ ...sx.root, ...sxProp }}>
          <Grid
            container
            justifyContent="center"
          >
            <Grid
              size={12}
              container
              spacing={isMobile ? 1 : 2}
            >
              {data?.pages?.map((pageData) => (
                <React.Fragment key={pageData?.pagination?.nextPage}>
                  {mergeVehiclesWithBanners(pageData?.inventory)
                    .map((item, index) => renderItem(item, index))}
                </React.Fragment>
              ))}
            </Grid>

            {/* {
              dataAutosCount && (
                <Grid
                  item
                  xs={11}
                  sm={6}
                  lg={3}
                  my={2}
                >
                  <Button
                    id="btn-cargar-mas-autos-auction"
                    variant="contained"
                    ref={loadMoreButtonRef}
                    onClick={() => fetchNextPage()}
                    disabled={!hasNextPage || isFetchingNextPage}
                    fullWidth
                    sx={sx.loadMoreButton}
                  >
                    <FormattedMessage id={loadMoreButtonText} />
                  </Button>
                </Grid>
              )
            } */}
          </Grid>
        </Box>
      </>
    )
  }

  if (isFetching) {
    return (
      <Box sx={{ ...sx.root, ...sxProp }}>
        <LinearProgress color="primary" />
      </Box>
    )
  }

  if (error) {
    return (
      <Box p={2}>
        <Contact
          title="API_ERROR_MESSAGE"
          description="CONTACT_INFO"
          showInfo={false}
          sx={{
            maxWidth: 500,
            background: 'none',
          }}
        />
      </Box>
    )
  }

  return null
}
export default memo(VehicleList)
